import type { ReactNode } from 'react';

export interface ErrorBannerProps {
    hasError: boolean;
    children: ReactNode;
}

export function ErrorBanner({ hasError, children }: ErrorBannerProps) {
    if (!hasError) {
        return null;
    }

    return (
        <div className="p-3 bg-red-600/10 border border-red-600/50 rounded-lg text-red-600 text-sm">
            {children}
        </div>
    );
}
